import type { PlanDifferencesRead } from "src/store/api/generatedApi";

interface MixIdChain {
  targets: number[];
  currentMixId: number;
}

/**
 * Walk backward through ancestors building the chain of target_mix_ids
 * reachable from `mixId`. Returns the ordered targets and the oldest
 * source_mix_id (`currentMixId`).
 */
export const buildMixIdChain = (
  ancestors: PlanDifferencesRead[],
  mixId: number
): MixIdChain =>
  ancestors.reduceRight<MixIdChain>(
    (acc, ancestor) => {
      const mixDiff = ancestor.differences.find(
        (d) => d.target_mix_id === acc.currentMixId
      );
      if (!mixDiff) return acc;
      return {
        targets: [...acc.targets, acc.currentMixId],
        currentMixId: mixDiff.source_mix_id,
      };
    },
    { targets: [], currentMixId: mixId }
  );
